import React, { Component } from 'react'
import ShowComponents from '../Common/ShowComponent'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import { Colors } from '../../../../Styles/Colors'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { withTranslation } from 'react-i18next';
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions'


class DocReviewPlanLeft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appointmentId: this.props.appointmentId,
      loading: false,
      isLocked: false,
      ReviewData: [],
    }
  }

  apiCalls = () => {
    this.getReviewPlan()
  }

  componentDidUpdate(prevprops) {
    if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.getReviewPlan() }
  }

  getReviewPlan = () => {
    try {
      this.setState({ loading: true })
      RestAPIService.getAll(Serviceurls.DOC_OPT_REVIEW_PALN + `?appointment_id=${this.state.appointmentId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let Data = [];
            if (response.data.data?.review_plan) {
              Data.push(response.data.data?.review_plan)
            }
            this.setState({
              ReviewData: Data,
              loading: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ loading: false })
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  render() {
    const { t } = this.props
    return (
      <ShowComponents onIntersection={this.apiCalls.bind(this)}>
        <Box height={'30vh'} overflow={'auto'} emed_tid="doc_review_plan_left_container">
          <Box component={'div'} sx={{ backgroundColor: Colors.white }} pt={'0.5vw'} emed_tid="doc_review_plan_left_table_wrapper">
            <Box component={'div'} pt={'0.5vw'} sx={{ border: '1px solid lightgray', maxHeight: '20vw', overflow: 'auto' }} emed_tid="doc_review_plan_left_table_box">
              <Table stickyHeader size='small' emed_tid="doc_review_plan_left_table">
                <TableHead emed_tid="doc_review_plan_left_table_head">
                  <TableRow emed_tid="doc_review_plan_left_table_head_row">
                    <TableCell sx={{ backgroundColor: Colors.Background }} emed_tid="doc_review_plan_left_duration_header">
                      <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="doc_review_plan_left_duration_header_text">Duration</Typography>
                    </TableCell>
                    <TableCell sx={{ backgroundColor: Colors.Background }} emed_tid="doc_review_plan_left_date_header">
                      <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="doc_review_plan_left_date_header_text">Review Date & Time</Typography>
                    </TableCell>
                    <TableCell sx={{ backgroundColor: Colors.Background }} emed_tid="doc_review_plan_left_comments_header">
                      <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="doc_review_plan_left_comments_header_text">Comments</Typography>
                    </TableCell>
                    <TableCell sx={{ backgroundColor: Colors.Background }} emed_tid="doc_review_plan_left_action_header">
                      <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="doc_review_plan_left_action_header_text">Action</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody emed_tid="doc_review_plan_left_table_body">
                  {
                    this.state.ReviewData?.length > 0 ? this.state.ReviewData?.map((item, index) => (
                      <TableRow key={index} emed_tid={`doc_review_plan_left_row_${index}`}>
                        <TableCell style={{ fontSize: "0.9vw" }} emed_tid={`doc_review_plan_left_duration_cell_${index}`}>{item?.duration ? `${item?.duration} ${item?.duration_type}` : '-'}</TableCell>
                        <TableCell emed_tid={`doc_review_plan_left_date_cell_${index}`}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }} emed_tid={`doc_review_plan_left_date_div_${index}`}>
                            <div style={{ fontSize: "0.9vw" }} emed_tid={`doc_review_plan_left_date_text_${index}`}>
                              {item?.review_date ? formatDate(item?.review_date) : "-"}
                              {item?.appointment_time ? " & " + item?.appointment_time : "-"}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell emed_tid={`doc_review_plan_left_comments_cell_${index}`}>
                          {item?.comments ? item?.comments?.length > 15 ?
                            <Tooltip placement='top' title={item?.comments} emed_tid={`doc_review_plan_left_comments_tooltip_${index}`}>
                              <Typography fontSize={'0.9vw'} emed_tid={`doc_review_plan_left_comments_text_${index}`}>{item?.comments?.slice(0, 15) + '...'}</Typography>
                            </Tooltip> :
                            <Typography fontSize={'0.9vw'} emed_tid={`doc_review_plan_left_comments_text_${index}`}>{item?.comments}</Typography> : '-'}
                        </TableCell>
                        <TableCell emed_tid={`doc_review_plan_left_action_cell_${index}`}>
                          <Box component={'div'} display={'flex'} alignItems={'center'} emed_tid={`doc_review_plan_left_action_box_${index}`}>
                            <Button className='Common_Btn_Min_Width' emed_tid={`doc_review_plan_left_edit_btn_${index}`}
                              disabled={this.state.isLocked || this.props.isLocked}
                              onClick={() => { this.props.EditReviewPlanData(item) }}
                            >
                              <Tooltip placement='top' title={'Edit'} emed_tid={`doc_review_plan_left_edit_tooltip_${index}`}>
                                {this.state.isLocked || this.props.isLocked ?
                                  <Box component={'img'} src={ImagePaths.DisabledEdit.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`doc_review_plan_left_edit_icon_disabled_${index}`} />
                                  :
                                  <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`doc_review_plan_left_edit_icon_${index}`} />
                                }
                              </Tooltip>
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )) : <TableRow emed_tid="doc_review_plan_left_no_data_row">
                      <TableCell />
                      <TableCell align='center' emed_tid="doc_review_plan_left_no_data_cell">No Records To Be Shown</TableCell>
                      <TableCell />
                    </TableRow>}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            emed_tid="doc_review_plan_left_error_toast"
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            emed_tid="doc_review_plan_left_success_toast"
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </ShowComponents>
    )
  }
}
export default withTranslation()(DocReviewPlanLeft)

